import 'selectize/dist/js/selectize.js';

'use strict';

var ad_select_img = function () {
  var self = this;

  self.init();
  self.bind();
};

ad_select_img.prototype.init = function () {
  var self = this;

  self.init_single(self);
  self.init_multiple(self);

};


ad_select_img.prototype.bind = function () {
  var self = this;

  jQuery(document).arrive('.ad_select_img.ad_select_img_single', function (localSelf) {
    localSelf.init_single();
  }.bind(null, self));

  jQuery(document).arrive('.ad_select_img.ad_select_img_multiple', function (localSelf) {
    localSelf.init_multiple();
  }.bind(null, self));


};

ad_select_img.prototype.init_single = function () {
  var self = this;

  jQuery('.ad_select_img.ad_select_img_single').each(function (/*index*/) {
    var element = jQuery(this);

    var selectize = element.find('select');

    if (element.hasClass('st_mounted') === false) {

      var add_enabled = false;

      if (element.hasClass('add_enabled') ) {
        add_enabled = true;
      }

// console.log(element);

      var options = self.get_options(selectize);

      selectize.selectize({
        create: false,
        copyClassesToDropdown: false,
        sortField: '$order',
        options: options,
        render: {
          item: self.init_single_item,
          option: self.init_single_option
        }
      });

      element.addClass('st_mounted');
    }

  });

};


ad_select_img.prototype.init_multiple = function () {
  var self = this;

  jQuery('.ad_select_img.ad_select_img_multiple').each(function (/*index*/) {
    var element = jQuery(this);

    var selectize = element.find('select');

    if (element.hasClass('st_mounted') === false) {

      var add_enabled = false;

      if (element.hasClass('add_enabled') ) {
        add_enabled = true;
      }

// console.log(element);

      var options = self.get_options(selectize);

      selectize.selectize({
        create: false,
        copyClassesToDropdown: false,
        sortField: '$order',
        options: options,
        render: {
          option: self.init_single_option
        }
      });

      element.addClass('st_mounted');
    }

  });

};


ad_select_img.prototype.get_options = function (select_element) {
  var self = this;

  var options = [];
  var options_elements = select_element.find('option')

  for (var i = 0; i <= options_elements.length; i++) {

    var element = jQuery(options_elements[i]);

    var element_options = {};

    element_options.value = element.attr('value');
    element_options.text = element.html();

    element_options.url = element.data('url');

    options.push(element_options);

  }

  return options;

};







ad_select_img.prototype.init_single_item = function (item, escape) {
  var self = this;

  var item_html = '';

  item_html += '<div class="ad_select_img__el_custom_item">';
    item_html += '<div class="ad_select_img__el_custom_table">';

      item_html += '<div class="ad_select_img__el_img" style="background-image: url('  + escape(item.url) + ');"></div>';
      item_html += '<div class="ad_select_img__el_text">' + escape(item.text) + '</div>';

    item_html += '</div>';
  item_html += '</div>';

  return item_html;

};



ad_select_img.prototype.init_single_option = function (option, escape) {
  var self = this;

  var option_html = '';
  // option_html = '<p>' + 'option: ' + escape(option.value) + '</b>';

  option_html = '<div class="ad_select_img__el_custom_option"' + '>';

    option_html += '<div class="ad_select_img__el_img" style="background-image: url('  + escape(option.url) + ');"></div>';
    option_html += '<div class="ad_select_img__el_text">' + escape(option.text) + '</div>';

  option_html += '</div>';

  return option_html;

};


jQuery( document ).ready(function() {

  window.ad_select_img = new ad_select_img();

});
